import { createApp } from 'vue'
import App from './App.vue'

// Vendored fonts (served locally; unicode-range ensures only needed subsets are downloaded)
// Lora – serif header/content font
import '@fontsource/lora/400.css'
import '@fontsource/lora/400-italic.css'
import '@fontsource/lora/500.css'
import '@fontsource/lora/600.css'
import '@fontsource/lora/700.css'
import '@fontsource/lora/700-italic.css'
// EB Garamond – serif marketing/editor font
import '@fontsource/eb-garamond/400.css'
import '@fontsource/eb-garamond/400-italic.css'
import '@fontsource/eb-garamond/500.css'
import '@fontsource/eb-garamond/600.css'
import '@fontsource/eb-garamond/700.css'
import '@fontsource/eb-garamond/700-italic.css'
// Manrope – sans-serif body/UI font
import '@fontsource/manrope/400.css'
import '@fontsource/manrope/500.css'
import '@fontsource/manrope/600.css'
import '@fontsource/manrope/700.css'

import './assets/styles/main.css'
import './assets/fonts.css'

const detectTablet = () => {
  const userAgent = navigator.userAgent.toLowerCase()
  const isIPad =
    /ipad/.test(userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  const isTabletUA = /tablet|ipad|playbook|silk|android(?!.*mobile)/i.test(
    userAgent
  )

  const width = window.innerWidth || window.screen.width
  const height = window.innerHeight || window.screen.height
  const minDimension = Math.min(width, height)
  const maxDimension = Math.max(width, height)

  const isTabletDimensions =
    minDimension >= 600 &&
    minDimension <= 1024 &&
    maxDimension >= 768 &&
    maxDimension <= 1366

  if (isIPad || isTabletUA || isTabletDimensions) {
    const viewport = document.querySelector('meta[name="viewport"]')
    if (viewport) {
      viewport.setAttribute(
        'content',
        'width=640, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
      )
    }
  }
}

detectTablet()

createApp(App).mount('#app')
